import {
  CaretDownOutlined,
  CloseOutlined,
  FileOutlined,
  HeartOutlined,
  LoginOutlined,
  LogoutOutlined,
  UserAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Badge, Col, Dropdown, Layout, Menu, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  ACCESS_TOKEN,
  APP_LANGUAGE,
  LANGUAES_MOBILE,
  LANGUAGES,
  ROUTER_PATH,
  USER_INFO,
  WIDTH_IPAD,
} from "../../common/constant";
import { signOut } from "../../redux/reducers/slice/auth";
import { selectCart } from "../../redux/reducers/slice/cart";
import { selectProfile } from "../../redux/reducers/slice/profile";
import { getMatchingRoute, localizeRouteKey } from "../../shared/helpers";
import { getFirstWordName, getVoucherInfo } from "../../utils/helpers";
import SearchBar from "../searchBar";
import HamburgerContent from "./hamburgerContent";
import IHeaderProps from "./IHeaderProps";
import "./style.scss";

const Header = (props: IHeaderProps) => {
  const refModal = useRef<any>(null);
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const { innerWidth } = window;
  const carts = useSelector(selectCart);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const slug = props.history.location.pathname.split("/");

  const { t } = useTranslation();
  const token = localStorage.getItem(ACCESS_TOKEN);
  let userInfo = JSON.parse(`${localStorage.getItem(USER_INFO)}`);
  const profile = useSelector(selectProfile);

  const voucherInfo = getVoucherInfo();

  useEffect(() => {
    if (!profile.loading && profile.isUpdatted) {
      userInfo = JSON.parse(`${localStorage.getItem(USER_INFO)}`);
    }
  }, [profile.isUpdatted]);

  const handleClickHeader = () => {
    if (slug && slug.length === 3 && !slug[slug.length - 1]) {
      window.location.href = window.location.origin + "/" + i18n.language;
    } else {
      props.history.push(localizeRouteKey(ROUTER_PATH.HOME));
    }
  };

  const handleClickCart = () => {
    props.history.push(localizeRouteKey(ROUTER_PATH.CART));
  };

  const handleClickProfileMenu = async ({ key }: any) => {
    if (key === ROUTER_PATH.SIGN_IN) {
      props.history.push(localizeRouteKey(ROUTER_PATH.SIGN_IN));
    }
    if (key === ROUTER_PATH.SIGN_UP) {
      props.history.push(localizeRouteKey(ROUTER_PATH.SIGN_UP));
    }
    if (key === ROUTER_PATH.PROFILE) {
      props.history.push(localizeRouteKey(ROUTER_PATH.PROFILE));
    }
    if (key === ROUTER_PATH.ORDERS) {
      props.history.push(localizeRouteKey(ROUTER_PATH.ORDERS));
    }
    if (key === ROUTER_PATH.PRODUCTS_WISH) {
      props.history.push(localizeRouteKey(ROUTER_PATH.PRODUCTS_WISH));
    }
    if (key === ROUTER_PATH.SIGN_OUT) {
      await dispatch(await signOut());
    }
  };

  const handleClickLanguagesMenu = ({ key }: any) => {
    if (key === APP_LANGUAGE.English) {
      props.history.push(getMatchingRoute(pathname, APP_LANGUAGE.English));
    }
    if (key === APP_LANGUAGE.Vietnamese) {
      props.history.push(getMatchingRoute(pathname, APP_LANGUAGE.Vietnamese));
    }
  };

  const handleClickHamburger = (bool: boolean) => setVisible(bool);

  const menus = (
    <Menu onClick={handleClickProfileMenu}>
      {token === null ? (
        <Menu.ItemGroup>
          <Menu.Item key={ROUTER_PATH.SIGN_IN} icon={<LoginOutlined />}>
            {t("btn_sign_in")}
          </Menu.Item>
          <Menu.Item key={ROUTER_PATH.SIGN_UP} icon={<UserAddOutlined />}>
            {t("btn_sign_up")}
          </Menu.Item>
        </Menu.ItemGroup>
      ) : (
        <Menu.ItemGroup>
          <Menu.Item key={ROUTER_PATH.PROFILE} icon={<UserOutlined />}>
            {t("user_information")}
          </Menu.Item>
          <Menu.Item key={ROUTER_PATH.ORDERS} icon={<FileOutlined />}>
            {t("user_manager_order")}
          </Menu.Item>
          <Menu.Item key={ROUTER_PATH.PRODUCTS_WISH} icon={<HeartOutlined />}>
            {t("user_wish")}
          </Menu.Item>
          <Menu.Item
            key={ROUTER_PATH.SIGN_OUT}
            danger
            icon={<LogoutOutlined />}>
            {t("btn_sign_out")}
          </Menu.Item>
        </Menu.ItemGroup>
      )}
    </Menu>
  );

  //if width screen >= iPad's width screen diplay full language name
  const languages = (
    <Menu onClick={handleClickLanguagesMenu} selectedKeys={[i18n.language]}>
      <Menu.ItemGroup>
        <Menu.Item key={APP_LANGUAGE.English} disabled>
          {innerWidth >= WIDTH_IPAD ? LANGUAGES.en : LANGUAES_MOBILE.en}
        </Menu.Item>
        <Menu.Item key={APP_LANGUAGE.Vietnamese}>
          {innerWidth >= WIDTH_IPAD ? LANGUAGES.vn : LANGUAES_MOBILE.vn}
        </Menu.Item>
      </Menu.ItemGroup>
    </Menu>
  );

  return (
    <Layout.Header
      className={`kd-header ${
        voucherInfo && voucherInfo.code ? "kd-header-voucher" : ""
      }`}>
      <Row align="middle" justify="space-between" style={{ height: "100%" }}>
        <Col className="kd-menu-hamburger">
          <a
            onClick={() => {
              if (refModal) {
                handleClickHamburger(!visible);
                refModal.current.toggleModal(!visible);
              }
            }}>
            {visible ? (
              <CloseOutlined style={{ fontSize: "25px", color: "#a19d95" }} />
            ) : (
              <img
                src="https://kdstore-testing.s3.amazonaws.com/product_images/1630036560-iconmenu-76.svg"
                alt="Menu"
                style={{ width: 30 }}
              />
            )}
          </a>
        </Col>

        <Col className="kd-logo-wrapper" sm={9} xl={8}>
          <a className={"kd-home"} onClick={(e) => handleClickHeader()}>
            <img
              className="logo"
              src="https://kdstore.s3-ap-southeast-1.amazonaws.com/static/icons/logo-kymdanshop-84.svg"
            />
          </a>
        </Col>

        <Col className="kd-search-wrapper" sm={6} xl={8}>
          <SearchBar history={props.history} />
        </Col>

        <Col className="kd-header-right" sm={9} xl={8}>
          <Row justify="end" align="middle">
            <Col className="back-to-kymdan">
              <a href="https://www.kymdan.com/">
                Về trang <span>kymdan.com</span>
              </a>
            </Col>
            <Col className="kd-shopping-cart">
              <a className="shopping-cart" onClick={(e) => handleClickCart()}>
                <Badge count={carts?.total_quantity} size="small">
                  {/* <ShoppingCartOutlined style={{ fontSize: "20px" }} /> */}
                  <img
                    style={{ width: 20 }}
                    src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_Cart-58.svg"
                    alt=""
                  />
                </Badge>
              </a>
            </Col>
            <Col className="kd-signin-signup">
              <Dropdown overlay={menus}>
                <a
                  className="kd-profile-text"
                  onClick={(e) => e.preventDefault()}>
                  {userInfo ? (
                    <Avatar size={20} src={userInfo.avatar}>
                      {!userInfo.avatar
                        ? getFirstWordName(userInfo.full_name)
                        : null}
                    </Avatar>
                  ) : (
                    <Avatar
                      size={20}
                      icon={
                        <img src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/Icon_Account-59.svg" />
                      }
                    />
                  )}
                </a>
              </Dropdown>
            </Col>
            <Col className="kd-language">
              <Dropdown overlay={languages}>
                <a
                  className="kd-profile-text"
                  onClick={(e) => e.preventDefault()}>
                  <span>
                    {innerWidth > WIDTH_IPAD - 1 //if width screen >= iPad's width screen diplay full language name
                      ? LANGUAGES[i18n.language]
                      : LANGUAES_MOBILE[i18n.language]}
                    <CaretDownOutlined />
                  </span>
                </a>
              </Dropdown>
            </Col>
          </Row>
        </Col>

        <Col className="kd-shopping-cart-mobile">
          <a className="shopping-cart" onClick={(e) => handleClickCart()}>
            <Badge count={carts?.total_quantity} size="small">
              {/* <ShoppingCartOutlined style={{ fontSize: "25px" }} /> */}
              <img
                style={{ width: 20 }}
                src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_Cart-58.svg"
                alt=""
              />
            </Badge>
          </a>
        </Col>
      </Row>
      <HamburgerContent
        handleClickHamburger={handleClickHamburger}
        ref={refModal}
        history={props.history}
      />
    </Layout.Header>
  );
};
export default Header;
